module.exports = __webpack_public_path__ + "6a584ec0f5071d013402f200f545a8f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/logo-softwearehouse.png
// module id = 854
// module chunks = 0 1